class SlideSelection {
    constructor(activeElement) {
        this.activeElement = activeElement;

        if (!this.activeElement) return;
        // this check if the “slider” variation is selected
        this.isOuterContainer = this.activeElement.getAttribute("data-outer-container");

        this.targetElement = this.activeElement.closest("[data-selection-container]").querySelector("[data-selection-target-element]");
        this.targetMediaId = this.targetElement.getAttribute("data-selected-media-id");
        this.newMediaId = this.activeElement.getAttribute("data-media-id");

        this.setInnerHtml();
    }

    setInnerHtml() {
        if (this.targetElement && (this.targetMediaId !== this.newMediaId)) {
            this.targetElement.classList.add("hidden");
            
            if (this.isOuterContainer && this.isOuterContainer === "true") {
                this.targetElement.innerHTML = this.activeElement.firstElementChild.innerHTML;
            } else {
                this.targetElement.innerHTML = this.activeElement.innerHTML;
            }

            this.targetElement.setAttribute("data-selected-media-id", this.newMediaId);

            new Media(this.targetElement);

            this.targetElement.querySelectorAll("[data-media-button-play]").forEach(button => button.removeAttribute("tabindex"));

            const debouncedOnSlide = debounce(() => {
                this.targetElement.classList.remove("hidden");
            }, 500);
            
            debouncedOnSlide();
        }
    }
}